import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiHeart, FiVideo, FiMessageCircle, FiUsers, FiClock } from 'react-icons/fi';
import { SectionHeading } from '../ui/SectionHeading';

export const SupportCommunity = () => {
  const supports = [
    { text: "Weekly live coaching", icon: FiVideo },
    { text: "Daily masterminds", icon: FiUsers },
    { text: "Private community", icon: FiMessageCircle },
    { text: "Accountability partners", icon: FiHeart },
    { text: "24/7 support system", icon: FiClock },
  ];

  return (
    <section className="py-24 px-4 bg-navy-900 border-y border-white/5">
      <div className="max-w-4xl mx-auto text-center">
        <SectionHeading subtitle="Get the guidance you need, exactly when you need it.">
          You Are Not Alone
        </SectionHeading>
        
        <div className="flex flex-wrap justify-center gap-4 mt-12">
          {supports.map((item, idx) => (
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              key={idx}
              className="bg-navy-800 border border-white/10 rounded-full py-3 px-6 flex items-center gap-3 text-gray-300"
            >
              <SafeIcon icon={item.icon} className="text-royal-400 text-xl" />
              <span className="font-medium">{item.text}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};